import {createActions} from 'client/framework';

export default createActions(null, ['UPDATE_INPUT', 'TOGGLE_TOP_FIVE']);
